import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Betriebskontakt } from '../../../../../projects/kiene-core/src/lib/components/stammdaten/betriebskontakte/betriebskontakt';

export type DashboardSammelstelleHerkunftPickData = {
    selectedKundeId?: number | null;
};

export type DashboardSammelstelleHerkunftPickResult = {
    kontakt: Betriebskontakt | null;
    clear?: boolean;
};

@Component({
    selector: 'kiene-dashboard-sammelstelle-herkunft-pick-dialog',
    templateUrl: './dashboard-sammelstelle-herkunft-pick-dialog.component.html',
    styleUrls: ['./dashboard-sammelstelle-herkunft-pick-dialog.component.scss'],
})
export class DashboardSammelstelleHerkunftPickDialogComponent {
    selectedKontakt: Betriebskontakt | null = null;

    constructor(
        private readonly dialogRef: MatDialogRef<
            DashboardSammelstelleHerkunftPickDialogComponent,
            DashboardSammelstelleHerkunftPickResult | null
        >,
        @Inject(MAT_DIALOG_DATA) public data: DashboardSammelstelleHerkunftPickData,
    ) {}

    onKontaktSelected(kontakt: Betriebskontakt): void {
        this.selectedKontakt = kontakt;
    }

    onKontakteSelected(kontakte: Betriebskontakt[]): void {
        if (kontakte?.length) {
            this.selectedKontakt = kontakte[0];
        }
    }

    apply(): void {
        if (!this.selectedKontakt) return;
        this.dialogRef.close({ kontakt: this.selectedKontakt });
    }

    clear(): void {
        this.dialogRef.close({ kontakt: null, clear: true });
    }

    close(): void {
        this.dialogRef.close(null);
    }
}
